import assignToGroup from './assign-to-group';
import assignToCa from './assign-to-ca';

export default {
	assignToGroup,
	assignToCa
};
